import { Injectable } from '@angular/core';
import { EndPoint } from '../models/app.settings.model';
import { MS_URL } from '../const/http.const';

@Injectable({
  providedIn: 'root',
})
export class AppSettings {
  public administration = {
    exitPoints: EndPoint.urlBase('administracion/puntos-salida'),
    calorificPower: EndPoint.urlBase('administracion/puntos-poder-calorifico'),
    customers: EndPoint.urlBase('administracion/clientes'),
    sections: EndPoint.urlBase('administracion/tramos'),
    gasSources: EndPoint.urlBase('administracion/fuentes'),
    societies: EndPoint.urlBase('administracion/sociedades'),
    cities: EndPoint.urlBase('administracion/ciudades-provincias'),
    relevantMarkets: EndPoint.urlBase('administracion/mercados-relevantes'),
    distributionSystems: EndPoint.urlBase(
      'administracion/sistemas-distribucion'
    ),
    generalInfo: EndPoint.urlBase('administracion/clientes/filters'),
  };

  public agents = {
    urls: {
      base: EndPoint.urlBaseAdmin('agentes'),
    },
  };

  public rolAgente = {
    urls: {
      base: EndPoint.urlBaseAdmin('rol-agente'),
    },
  };

  public consumptionURL = EndPoint.urlBase(MS_URL.CONSUMPTION);
  public predictionURL = EndPoint.urlBase(MS_URL.PREDICTION);
  public adminURL = EndPoint.urlBase(MS_URL.ADMIN);

  public standardPrediction = {
    urls: {
      base: EndPoint.urlBasePrediction('calendario/prediccion/standard'),
      edit: EndPoint.urlBasePrediction('calendario/prediccion/standard/edit'),
      temporal: EndPoint.urlBasePrediction(
        'calendario/prediccion/standard/temporal'
      ),
      generate: EndPoint.urlBasePrediction(
        'calendario/prediccion/standard/generate'
      ),
    },
  };

  public estacionalPrediction = {
    urls: {
      base: EndPoint.urlBasePrediction('calendario/prediccion/seasonal'),
      edit: EndPoint.urlBasePrediction('calendario/prediccion/seasonal/edit'),
      temporal: EndPoint.urlBasePrediction(
        'calendario/prediccion/standard/temporal'
      ),
      generate: EndPoint.urlBasePrediction('calendario/prediccion/seasonal/'),
      baseEstacional: EndPoint.urlBasePrediction('calendario/prediccion'),
      getEstacional: EndPoint.urlBasePrediction(
        'calendario/prediccion/seasonal/get'
      ),
    },
  };

  public sso = {
    urls: {
      postVerifyToken: EndPoint.urlBaseAdmin('sso/verify-token'),
      logout: EndPoint.urlBaseAdmin('sso/logout'),
      refresh: EndPoint.urlBaseAdmin('sso/refresh-token'),
    },
  };

  public atr = {
    urls: {
      base: EndPoint.urlBaseConsumption('consumo/get/detail-atr'),
    },
  };

  public gi = {
    urls: {
      base: EndPoint.urlBaseConsumption('consumo/get/detail-gi'),
    },
  };

  public fineAdjustment = {
    urls: {
      base: EndPoint.urlBasePrediction('calendario/prediccion/fine-adjustment'),
    },
  };

  public customerAdjustmentHistory = {
    urls: {
      base: EndPoint.urlBasePrediction(
        'calendario/prediccion/fine-adjustment/clients-log'
      ),
    },
  };

  public exitPointsAdjustmentHistory = {
    urls: {
      base: EndPoint.urlBasePrediction(
        'calendario/prediccion/fine-adjustment/cg-log'
      ),
    },
  };

  public cityGates = {
    urls: {
      base: EndPoint.urlBase('administracion/clientes/filters/city-gates'),
    },
  };

  public poderCalorificoNomination = {
    urls: {
      base: EndPoint.urlBaseAdmin('poderes-calorificos'),
      upload: EndPoint.urlBaseAdmin('poderes-calorificos/upload'),
    },
  };

  public app = {
    name: 'Nominaciones',
    version: '2.3.0',
  };
}
